import { __assign } from "tslib";
import * as React from 'react';
import { memo } from 'react';
var SvgChevronCircleDown = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", "data-test-id": "icons-chevron-circle-down", viewBox: "0 0 24 24", role: "img" }, props),
    React.createElement("title", null, 'Chevron Circle Down Icon'),
    React.createElement("g", { clipPath: "url(#clip0_3283_33)" },
        React.createElement("path", { fill: "currentColor", d: "M2 12c0 5.5 4.5 10 10 10s10-4.5 10-10S17.5 2 12 2 2 6.5 2 12m15.8-2.2c.4.4.4 1 0 1.4L13 15.9c-.7.7-1.4.7-2 0l-4.7-4.8c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l4.2 4.2c.1.1.2.1.3 0l4.2-4.2c.3-.3 1-.3 1.4.1" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0_3283_33" },
            React.createElement("path", { fill: "currentColor", d: "M0 0h24v24H0z" }))))); };
var Memo = memo(SvgChevronCircleDown);
export default Memo;
//# sourceMappingURL=ChevronCircleDown.js.map